﻿import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild, ElementRef, ViewContainerRef   } from "@angular/core";
import { ActivatedRoute, Router} from "@angular/router";
import { DataService } from "../services/dataService";
import { TextBoxComponent } from "../shared/Textbox/textBox.component";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Subject,Observable,of } from "rxjs";
import { map,  catchError } from 'rxjs/operators';

import * as moment from 'moment';

import { CalendarComponent } from "./calendar.component";
import { Role } from ".././models/role.model";
import { Location } from ".././models/location.model";
import { CalendarType } from ".././models/CalendarType.model";
import { FormatDateTimePipe } from "../pipes/formatDateTime.pipe";
import { RelatedPersonFilterPipe } from "../pipes/relatedperson-filter.pipe";
import {CalendarDetail, RelatedParty, FutureHearing,  RelatedPetitions } from "../models/calendarDetail.model";
declare let jsPDF;
declare var $: any;

@Component({
    selector: "jax-searchcalendarcomponent",
    templateUrl: "./searchCalendar.component.html",
    host: { "(document: keyup)": "keyup($event)" }
})
export class SearchCalendarComponent implements OnInit {
    public data;

    public names: string[] = ["Please type"];
    public errorMessage: string;
    public calendarName: string;
    public validationMessage: ValidationMessage;
    public searchCompleted = false;
    public hasError= false;
    public searchClicked = false;
    public calendarType: number=0;
    public todayDate: string;
    public roleselected: boolean;
    public IsValidateError: boolean = false;

    public calendar: any = {};
    public roles: Role[] = [];
    public locations: Location[] = [];
    public calendartypes: CalendarType[] = [];

    public currentUser: any;
    public userId: number;

    public completefalg: boolean = false;
    public noMatchFoundText: string;

    public calendarHeaderTitle: string;
    public calendarHeaderLocation: string;
    public calendarHeaderDates: string;


    @ViewChild("search") searchButton: ElementRef;


    constructor(private route: ActivatedRoute,
        private dataService: DataService,
        private router: Router,
        private sanitizer: DomSanitizer,
        private elementref: ElementRef) {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userId = this.currentUser.UserId;
        }
    }

    public observableSource = (keyword: any): Observable<any[]> => {
        let url: string = "Calendar/searchname?roleId=" + this.calendar.role + "&nameLiteral=" + keyword;
        if (keyword) {
            let list= this.dataService.get(url).map((res) => {
                    let json = res;
                    return json;
                });
            return list;
        } else {
            return of([]);
        }
    }

    public ngOnInit() {
        this.todayDate = moment(new Date()).format("YYYY-MM-DD");
        this.calendar.startDate = this.todayDate;
        this.calendar.endDate = this.todayDate;
        this.getRole();
        this.getCalendarType();
        this.getLocation();
    }

    public onSelectCase(caseNumber: string, caseId: number) {
        if (caseNumber) {
            this.router.navigate(["../casedetail"],
                { relativeTo: this.route, queryParams: { CaseNumber: caseNumber, CaseID: caseId } });
        }
    }

    public convertToPdf() {
        let fileName = this.calendarName + ".pdf";
        this.createPDF(fileName);
    }

    public onSelectDate($event: any, calControl: any) {
        this.calendar.startDate = $event.format("YYYY-MM-DD");
        this.searchCalendar(calControl);
    }

    public onToggle($event: any) {
        this.calendar.calendarType = $event;
    }

    public searchCalendar(calendarcomp: CalendarComponent) {
        this.data = "";
        this.searchCompleted = false;
        this.searchClicked = false;
        this.hasError = false;
        this.calendarHeaderTitle = this.getCalendarTitle();
        this.calendarHeaderLocation = this.getLocationName();
        this.calendarHeaderDates = this.getCalendarHeaderDate();
        calendarcomp.calType = this.calendar.calendarType;
        if (!this.validateSearchCriteria()) {
            this.searchClicked = true;
            this.calendar.searchMode = 0;
            this.calendar.UserID = this.userId;
            this.calendarType = this.calendar.calendarType;
            this.data = "";
            if (this.calendar.calendarType == 2) {
                this.dataService.post("Calendar/searchcalendardetail", JSON.stringify(this.calendar)).subscribe(
                    (response) => {
                        this.data = response;
                        this.searchCompleted = true;
                    },
                    (error) => {
                        if (error._body !== "") {
                            this.errorMessage = error.message;
                        } else {
                            this.errorMessage = error.statusText;
                        }
                        this.searchCompleted = true;
                        this.hasError = true;
                    }
                );
            } else {
                let tempDate = this.calendar.startDate;
                this.calendar.startDate = moment(moment(this.calendar.startDate).startOf("month").toDate())
                    .format("YYYY-MM-DD");
                this.calendar.endDate = moment(moment(this.calendar.startDate).endOf("month").toDate())
                    .format("YYYY-MM-DD");

                this.dataService.post("Calendar/searchcalendar", JSON.stringify(this.calendar)).subscribe(
                    (response) => {
                        this.data = response;
                        this.searchCompleted = true;
                        calendarcomp.events = [];
                        let availableData = this.getScheduleAvailableData(this.calendar.startDate, this.calendar.endDate);
                        this.calendar.startDate = tempDate;
                        calendarcomp.displayCalendar(this.data, availableData, this.calendar.calendarType==0?"Schedule":"Available", tempDate);
                    },
                    (error) => {
                        if (error._body !== "") {
                            if (typeof error.message === "string" || error.message instanceof String) {
                                this.errorMessage = error.message;
                            } else {
                                this.errorMessage = error.statusText;    
                            }
                        } else {
                            this.errorMessage = error.statusText;
                        }
                        this.searchCompleted = true;
                        this.hasError = true;
                    }
                );
            }
        }
    }

    public searchName() {
        this.dataService.post("Calendar/searchname", JSON.stringify(this.calendar)).subscribe(
            (response) => {
                this.names = response;
            },
            (error) => {
            }
        );
    }

    public getUri() {
        if (Number(this.calendar.nameOrBarId) === NaN) {
            this.noMatchFoundText = "No Result Found";
        } else {
            this.noMatchFoundText = "";
        }
        return this.dataService.apiBaseUrl +
            "Calendar/searchname?roleId=" +
            this.calendar.role +
            "&nameLiteral=:nameStartsWith";
    }

    public getRole() {
        this.dataService.get("common/roles").subscribe(resp => {
                this.roles = resp;
                //this.roles.unshift(new Role());
                this.calendar.role = 1;
                this.roleselected = true;
            },
            (error) => {
            });
    }

    public getLocation() {
        this.dataService.get("common/locations").subscribe(resp => {
                this.locations = resp;
                this.locations.unshift(new Location());
                this.calendar.location = 1;
            },
            (error) => {
            });
    }

    public getLocationName() {
        return this.locations.find(f => f.Id.toString() === this.calendar.location.toString()).Name;
    }

    public getCalendarHeaderDate() {
        let sd = new FormatDateTimePipe().transform(this.calendar.startDate, "MM/DD/YYYY");
        let ed = new FormatDateTimePipe().transform(this.calendar.endDate, "MM/DD/YYYY");

        return sd + " thru " + ed;
    }

    public getCalendarType() {
        this.dataService.get("common/calendartypes").subscribe(resp => {
                this.calendartypes = resp;
                this.calendar.calendarType = 1;
            },
            (error) => {
            });
    }

    public clearSearch() {
        this.calendar.nameOrBarId = "";
        this.calendar.role = -1;
        this.calendar.calendarType = 1;
        this.calendar.location = 1;
        this.calendar.startDate = this.todayDate;
        this.calendar.endDate = this.todayDate;
        this.data = "";
        this.searchClicked = false;
        this.validationMessage = null;
        this.searchCompleted = false;
    }

    private resetRoleSelection() {
        this.roleselected = false;
        this.calendar.nameOrBarId = "";
        this.searchCompleted = false;
        this.searchClicked = false;
        this.data = "";
        if (this.calendar.role >= 0) {
            this.roleselected = true;
        }

        if (this.calendar.role == 2653)
            this.calendarName = "Judicial";
        else if (this.calendar.role == 37187418)
            this.calendarName = "AG";
        else
            this.calendarName = "Agency";
    }

    public getCalendarTitle() {
        return this.roles.find(r => r.Id.toString() === this.calendar.role.toString()).Name + " Calendar";
    }

    private isValidString(val: any) {
        return (val !== "undefined" && val);
    }

    private validateSearchCriteria() {
        this.validationMessage = null;
        let msg = new ValidationMessage();
        msg.messageType = ValidationMessageType.Error;
        let isError = false;
        let errorMessage: string;
        errorMessage = "<ul>";

        if (this.calendar.role === -1) {
            isError = true;
            errorMessage = errorMessage + "<li>Role is required</li>";
        }

        if (this.calendar.role > 0 && !this.isValidString(this.calendar.nameOrBarId) && this.calendar.calendarType != 2) {
            isError = true;
            errorMessage = errorMessage +
                "<li>Name or Bar Id  is required field if calendar type is Scheduled/Available</li>";
        }

        if (this.calendar.startDate === "") {
            isError = true;
            errorMessage = errorMessage + "<li>Start date cannot be empty</li>";
        } else if (this.calendar.endDate !== "" &&
            this.calendar.startDate > this.calendar.endDate &&
            this.calendar.calendarType == 2) {
            isError = true;
            errorMessage = errorMessage + "<li>Start date cannot be greater than end date</li>";
        }

        errorMessage = errorMessage + "</ul>";

        if (isError) {
            msg.message = errorMessage;
            this.validationMessage = msg;
        } else {
            $.fn.collapse("#search", "#searchcalendar");
        }

        return isError;
    }

    public autocompleListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data}</span>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    private createPDF(filename: string) {
        var doc = new jsPDF();
        var blockHeight;
        var top = 30;
        var recno = 1;


        this.createHeader(doc, this.calendarHeaderTitle, this.calendarHeaderLocation, this.calendarHeaderDates);
        for (var cd of this.data) {

            cd = this.getSanitizedPDFData(cd);

            blockHeight = 38 +
                (cd.RelatedParty.length * 4.1) +
                (cd.FutureHearing.length * 4.1) +
                (cd.RelatedPetitions.length * 4.1);

            //Create new page if the next block height is more then page size
            if (top + blockHeight > 280) {
                doc.addPage();
                this.createHeader(doc, this.calendarHeaderTitle, this.calendarHeaderLocation, this.calendarHeaderDates);
                top = 30;
            }

            //Create block
            if (recno % 2 === 0) {
                doc.setFillColor(255);
            } else {
                doc.setFillColor(245);
            }
            recno = recno + 1;

            doc.rect(10, top, 190, blockHeight, "F");

            //Create line with case display number
            top = top + 6;
            doc.setFont("Helvetica Neue", "bold");
            doc.setFontSize(10);
            doc.setTextColor(51, 141, 205);
            doc.text(15, top, cd.CaseDisplayNumber + " " + cd.StartDateTime);

            //Create Text for commissioner name
            doc.setTextColor(0, 0, 0);
            doc.setFontType("normal");
            doc.text(90, top, cd.EntityName + " - " + cd.Location);

            //Create line with Hearing Type
            top = top + 7;
            doc.setFontType("bold");
            doc.text(15, top, "Hearing Type : ");
            doc.setFontType("normal");
            doc.text(40, top, cd.HearingType + " - " + cd.HearingSubType);

            //Create line with Related Person table
            top = top + 5;
            doc.setFontType("bold");
            doc.text(15, top, "State of Arizona Vs");

            top = top + 2;
            var rows = cd.RelatedParty;
            doc.autoTable(this.getRelatePartiesCol(),
                rows,
                {
                    styles: {
                        cellPadding: 0,
                        columnWidth: "auto",
                        lineColor: 235,
                        fillColor: 253,
                        lineWidth: 0.05,
                        fontSize: 10,
                        font: "Helvetica Neue",
                        fontStyle: "normal"
                    },
                    theme: "plain",
                    margin: { top: top, left: 15 },
                    showHeader: "never",
                    addPageContent: function(data) {
                    }
                });

            //Create line with future hearing table
            top = doc.autoTable.previous.finalY + 5;
            doc.setFont("Helvetica Neue", "bold");
            doc.setFontSize(10);
            doc.setFontType("bold");
            doc.text(15, top, "Future Hearings:");

            top = top + 2;
            rows = cd.FutureHearing;
            doc.autoTable(this.getFutureHearingCol(),
                rows,
                {
                    styles: {
                        cellPadding: 0,
                        columnWidth: "auto",
                        lineColor: 235,
                        fillColor: 253,
                        lineWidth: 0.05,
                        fontSize: 10,
                        font: "Helvetica Neue",
                        fontStyle: "normal"
                    },
                    theme: "plain",
                    margin: { top: top, left: 15 },
                    showHeader: "never",
                    addPageContent: function(data) {
                    }
                });

            //Create line with Related Petition table
            top = doc.autoTable.previous.finalY + 5;
            doc.setFont("Helvetica Neue", "bold");
            doc.setFontSize(10);
            doc.setFontType("bold");
            doc.text(15, top, "Related Petitions:");
            rows = cd.RelatedPetitions;
            top = top + 2;
            doc.autoTable(this.getRelatedPetitionsCol(),
                rows,
                {
                    styles: {
                        cellPadding: 0,
                        columnWidth: "auto",
                        lineColor: 235,
                        fillColor: 253,
                        lineWidth: 0.05,
                        fontSize: 10,
                        font: "Helvetica Neue",
                        fontStyle: "normal"
                    },
                    theme: "plain",
                    margin: { top: top, left: 15 },
                    showHeader: "never",
                    addPageContent: function(data) {
                    }
                });

            top = doc.autoTable.previous.finalY + 5;

        }
        doc.save(filename);
    }

    private getRelatePartiesCol() {
        var columns = [
            { title: "Name", dataKey: "Name" },
            { title: "Role", dataKey: "Role" },
            { title: "Attorney", dataKey: "Attorney" }
        ];
        return columns;
    }

    private getFutureHearingCol() {
        var columns = [
            { title: "DateTime", dataKey: "HearingDateTime" }
        ];
        return columns;
    }

    private getRelatedPetitionsCol() {
        var columns = [
            { title: "PetitionDate", dataKey: "PetitionDate" }
        ];
        return columns;
    }

    private getSanitizedPDFData(cd: any) {
        let caldetail: CalendarDetail = new CalendarDetail();
        caldetail.CaseDisplayNumber = cd.CaseDisplayNumber;
        caldetail.StartDateTime = new FormatDateTimePipe().transform(cd.StartDateTime, "MM/DD/YYYY  hh:mm:ss A");
        caldetail.EntityName = cd.EntityName;
        caldetail.Location = cd.Location;
        caldetail.HearingType = cd.HearingType;
        caldetail.HearingSubType = cd.HearingSubType;
        caldetail.RelatedParty = [];

        let dt: string;

        for (let rp of cd.RelatedParty) {
            let party: RelatedParty = new RelatedParty();

            party.Role = rp.Role;

            dt = new FormatDateTimePipe().transform(rp.DOB, "MM/DD/YYYY");
            if (dt !== "01/01/0001") {
                party.Name = rp.Name + " (" + dt + ")";
            } else {
                party.Name = rp.Name;
            }

            if (rp.BarNumber !== null && rp.BarNumber !== "") {
                party.Attorney = rp.Attorney + " (" + rp.BarNumber + ")";
            } else {
                party.Attorney = rp.Attorney;
            }
            caldetail.RelatedParty.push(party);
        }

        caldetail.FutureHearing = [];
        for (let fh of cd.FutureHearing) {
            let hearing: FutureHearing = new FutureHearing();
            hearing.HearingDateTime = new FormatDateTimePipe().transform(fh.HearingDateTime, "MM/DD/YYYY  hh:mm:ss A") +
                " " +
                fh.HearingType +
                " - " +
                fh.HearingSubType;
            caldetail.FutureHearing.push(hearing);
        }

        caldetail.RelatedPetitions = [];
        for (let rp of cd.RelatedPetition) {
            let petition: RelatedPetitions = new RelatedPetitions();
            petition.PetitionDate = new FormatDateTimePipe().transform(rp.PetitionDate, "MM/DD/YYYY") +
                " " +
                rp.PetitionType;
            caldetail.RelatedPetitions.push(petition);
        }

        return caldetail;
    }

    private createHeader(doc: any, title: string, location: string, dateRange: string) {
        doc.setFillColor(41, 128, 186);
        doc.rect(10, 10, 190, 30, "F");
        doc.setFont("Helvetica Neue", "bold");
        doc.setFontSize(13);
        doc.setTextColor(255, 255, 255);
        let left = (190 - title.length) / 2;
        doc.text(left, 17, title);
        left = (190 - location.length) / 2;
        doc.text(left, 22, location);
        left = (190 - dateRange.length) / 2;
        doc.text(left, 27, dateRange);
    }

    private getScheduleAvailableData(startDate: any, endDate: any) {
        let startTime = "08:00";
        let endTime = "17:00";
        let fullavailabledata: any = [];

        let st = "";
        let et = "";
        let curDate = moment(startDate);

        do {
            let addEndTime = true;
            let availabledata: any = [];
            let datafilter: any = this.data.filter(c => moment(c.StartDateTime).isSame(curDate, "D"));
            if (datafilter.length === 0) {
                let tempData = {
                    EndDateTime: moment(curDate.format("YYYY-MM-DD") + "T" + endTime, "YYYY-MM-DD HH:mm:ss").toDate(),
                    StartDateTime: moment(curDate.format("YYYY-MM-DD") + "T" + startTime, "YYYY-MM-DD HH:mm:ss").toDate(),
                    CaseDisplayNumber: "Available",
                    HearingType: ""
                }
                availabledata.push(tempData);
                fullavailabledata = fullavailabledata.concat(availabledata);
            } else {
                for (let d of datafilter) {
                    if (d.EndDateTime.indexOf(endTime) >=0 ) {
                        addEndTime = false;
                    }

                    if (this.CompareDateTime(d.StartDateTime, curDate.format("YYYY-MM-DD") + "T" + startTime) && st === "") {
                        st = moment(curDate.format("YYYY-MM-DD") + "T" + startTime).format("YYYY-MM-DD HH:mm:ss");
                        et = moment(d.StartDateTime).format("YYYY-MM-DD HH:mm:ss");
                    } else if (st === "" || st === d.StartDateTime) {
                        st = d.EndDateTime;
                    }

                    if (this.CompareDateTime(d.StartDateTime, et)) {
                        et = moment(d.StartDateTime).format("YYYY-MM-DD HH:mm:ss");
                    }

                    if (st !== "" && et !== "") {
                        if (this.CompareDateTime(et, st)) {
                            let tempData = {
                                EndDateTime: et,
                                StartDateTime: st,
                                CaseDisplayNumber: "Available",
                                HearingType: ""
                            }
                            availabledata.push(tempData);
                        }
                        if (d.EndDateTime.indexOf(endTime) > -1) {
                            et = "";
                            st = "";
                            break;
                        } else {
                            st = d.EndDateTime;
                        }

                    }
                }
                if (availabledata.indexOf(endTime) <= -1 && addEndTime && st.indexOf(endTime)<0) {
                    let tempData = {
                        EndDateTime: moment(curDate.format("YYYY-MM-DD") + "T" + endTime).format("YYYY-MM-DD HH:mm:ss"),
                        StartDateTime: st,
                        CaseDisplayNumber: "Available",
                        HearingType: ""
                    }
                    availabledata.push(tempData);
                }
                if (availabledata.length > 0) {
                    fullavailabledata = fullavailabledata.concat(availabledata);
                }
                st = "";
                et = "";
            }
            curDate = moment(curDate, "YYYY-MM-DD").add(1, "days");
        } while (curDate <= moment(endDate, "YYYY-MM-DD"))
        return fullavailabledata;
    }

    private CompareDateTime(leftDate: any, rightDate: any) :boolean {
        let date1 = moment(leftDate, "YYYY-MM-DD HH:mm:ss").toDate();
        let date2 = moment(rightDate, "YYYY-MM-DD HH:mm:ss").toDate();;
        if (date1.getTime() > date2.getTime())
            return true;
        else
            return false;

    }

 

    private keyup(event: KeyboardEvent): void {
        if (event.keyCode === 13 ) {
            let el: HTMLElement = this.searchButton.nativeElement as HTMLElement;
            el.click();
        }
    }


}
